__turbopack_context__.v({
  "className": "plantinmtfont_e0c2fd53-module__0YLDhW__className",
  "variable": "plantinmtfont_e0c2fd53-module__0YLDhW__variable",
});
